import React from 'react';
import './Testimonials.css';

const testimonialsData = [
    {
        quote: (
            <>
                "The best place for laser hair removal treatments! They treat all skin tones safely and I love that the
                providers are Registered Nurses!"
            </>
        ),
        client: 'Teddy',
        location: 'Phoenix, AZ',
    },
    {
        quote: (
            <>
                "My only regret? Not doing this sooner and wasting money on those sketchy at-home IPL devices from
                Instagram ads. Just go here instead, thank me later!"
            </>
        ),
        client: 'Alyssa',
        location: 'Crystal Lake, IL',
    },
    {
        quote: (
            <>
                "I love how you pay one price and you’re a forever client and can come back as much as you want!
                Everyone is very friendly and makes sure you are comfortable!"
            </>
        ),
        client: 'Ariana',
        location: 'St. Louis, MO',
    },
    {
        quote: (
            <>
                "I have PCOS and embarrassing facial hair. I wanted to try Milan due to the locations and lifetime
                touchups. In one session I had more improvement than I had seen through other stuff."
            </>
        ),
        client: 'Rachel',
        location: 'Fairless Hills, PA',
    },
    {
        quote: (
            <>
                "One of the best gifts I’ve given myself! The extra time from not having to shave is a blessing. It is a
                relief to know that as hormones change I can come back with no additional costs."
            </>
        ),
        client: 'Katherine',
        location: 'Lexington, KY',
    },
    {
        quote: (
            <>
                "I have seen a huge difference in the amount of hair, I am pretty much hairless! Not really painful and
                really happy with my results so far!"
            </>
        ),
        client: 'Nicole',
        location: 'Long Island, NY',
    },
];

type TestimonialCardProps = {
    quote: React.ReactNode;
    client: string;
    location: string;
};

const TestimonialCard = ({ quote, client, location }: TestimonialCardProps) => (
    <div className="googlelp-testimonial-card flex flex-column justify-between p-3 p-md-4">
        <p className="googlelp-testimonial-quote mcl-font-proxima mb-2 text-start">{quote}</p>
        <div className="googlelp-testimonial-author align-text-right">
            <p className="googlelp-testimonial-author mcl-font-proxima mb-0 text-end">
                <strong>{client}</strong>
            </p>
            <p className="googlelp-testimonial-location mcl-font-proxima mb-0 text-end">{location}</p>
        </div>
    </div>
);

export function Testimonials() {
    return (
        <section className="googlelp-testimonials flex flex-column text-center">
            <div className="googlelp-container">
                <h2 className="mcl-font-greycliff mb-0">Our clients love us</h2>
                <p className="googlelp-testimonials-subheader mcl-font-proxima mb-0 pt-2 pb-3 px-0 pb-md-5">
                    Real stories, real confidence
                </p>
            </div>
            <div className="googlelp-testimonial-cards justify-content-start justify-content-md-center testimonials-grid-container m-0 m-md-auto">
                {testimonialsData.map((testimonial, index) => (
                    <TestimonialCard key={index} {...testimonial} />
                ))}
            </div>
        </section>
    );
}

export default Testimonials;
